// extracted by mini-css-extract-plugin
module.exports = {"lastComment":"lastComment__r5EGi","prepend":"prepend__3SWXN","text":"text__MZgWR","noComment":"noComment__hEwER","unread":"unread__Hmaq-","link":"link__uMiVm"};